module.exports = __webpack_public_path__ + "static/img/album-status-6.c46e6de5.png";